import { getEditLocation } from "../../../core/util/functions";

export const settingsLocation = "/settings/changepassword"


